module.exports = __webpack_public_path__ + "img/tw.480a00d6.svg";